import {SOPutEntity} from '../../core/entity/so-put-entity';
import {EntityCore} from './entity.core';
import {SOGetEntity} from '../../core/entity/so-get-entity';
import {FormField, SelectionOption} from 'lionheartland';
import {putEntityFormFieldOptions} from './put-entity-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutEntity extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putEntityFormFieldOptions);

  RequestClass = SOPutEntity

  constructor(
    public entityCore: EntityCore
  ) {
    super();
    if (putEntityFormFieldOptions.project) {
      putEntityFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('editPermissions'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}